
import { Options, Vue } from 'vue-class-component';
import { ProviderPortalClient } from '@/services/DueDiligenceServices';
import * as DDM from '@/dueDiligenceModels';

@Options({})
export default class ProviderDashboard extends Vue {

    dashboard: DDM.ProviderDashboardVM = null;

    created() {
        this.init();
    }

    init() {
        ProviderPortalClient.getDashboard()
        .then(x => {
            this.dashboard = x;
        });
    }

    getStatusLabel(status: DDM.ProviderProfileStatus): string {
        return DDM.getStatusLabel(status);
    }

    getStatusClass(status: DDM.ProviderProfileStatus): string {
        switch (status) {
            case DDM.ProviderProfileStatus.Invited: return "bg-secondary";
            case DDM.ProviderProfileStatus.Accepted: return "bg-info";
            case DDM.ProviderProfileStatus.DataCompleted: return "bg-primary";
            case DDM.ProviderProfileStatus.SurveyCompleted: return "bg-success";
            default: return "bg-secondary";
        }
    }

    goToSurvey() {
        if (this.dashboard.surveyCompleted) {
            this.$router.push('/provider/survey/results');
        } else if (this.dashboard.profileCompleted) {
            this.$router.push('/provider/survey');
        }
    }
}
